import {
  ADVERTISING,
  ANALYTICS,
  ESSENTIAL,
  PERFORMANCE,
  SOCIAL_NETWORKING,
} from 'constants/categories'

// ////////////////////////////////////////////////////////////////////
//
// See https://github.com/WordPress/wp-consent-level-api/tree/master
// for WP API docs
//
// ////////////////////////////////////////////////////////////////////

const TERMLY_TO_WP_CONSENT_CATEGORIES = {
  [ADVERTISING]: 'marketing',
  [ANALYTICS]: [
    'statistics',
    'statistics-anonymous',
  ],
  [ESSENTIAL]: 'functional',
  [PERFORMANCE]: 'preferences',
  [SOCIAL_NETWORKING]: 'marketing',
}

const TERMLY_TO_WP_CONSENT_TYPES = {
  opt_in: 'optin',
  opt_out: 'optout',
}


export default {
  initialize({ consentType }) {
    // I was inclined to test isEnabled() here, but the reference
    // I'm using doesn't, so I'm not going to try to be clever.

    window.wp_consent_type = TERMLY_TO_WP_CONSENT_TYPES[consentType]

    document.dispatchEvent(new CustomEvent('wp_consent_type_defined'))
  },

  send(consents) {
    if ( !isEnabled() ) {
      return
    }

    for ( const [category, wpCategory] of Object.entries(TERMLY_TO_WP_CONSENT_CATEGORIES) ) {
      const isConsented = ( category === ESSENTIAL ) ? true : consents[category]
      const wpValue = boolToName(isConsented)

      const wpCats = ( Array.isArray(wpCategory) ) ? wpCategory : [wpCategory]

      wpCats.forEach((wpCat) => {
        window.wp_set_consent(wpCat, wpValue)
      })
    }
  },
}

// Implemented as a function instead of a constant so that if the
// wp_set_consent function is created after resource-blocker loads,
// we'll still be able to use it.
//
function isEnabled() {
  return ( typeof window.wp_set_consent === 'function' )
}

function boolToName(bool) {
  return ( bool ) ? 'allow' : 'deny'
}
